import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatMain_Interface, Empty_AzmoonMaharatMain_Interface } from 'src/app/Interface/AzmoonMaharatMain_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-AzmoonMaharatMainList',
  templateUrl: './AzmoonMaharatMainList.component.html',
  styleUrls: ['./AzmoonMaharatMainList.component.scss']
})
export class AzmoonMaharatMainListComponent implements OnInit {

  Token: String = ""
  Filter_title: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private AzmoonMaharat_Service: AzmoonMaharatService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  DataList_AzmoonMaharat: Array<AzmoonMaharatMain_Interface> = []
  Data_Seleted_Delete: AzmoonMaharatMain_Interface = Empty_AzmoonMaharatMain_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2217).subscribe(
      data => {
        this.ReadData_AzmoonMaharat()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_AzmoonMaharat() {
    this.Procssing = true
    this.AzmoonMaharat_Service.GetRecord(this.Token).subscribe(
      data => {
        this.DataList_AzmoonMaharat = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }

  Delete(item: AzmoonMaharatMain_Interface) {
    this.Procssing = true
    this.modalRef_Delete.hide()
    this.AzmoonMaharat_Service.DeleteAzmoonMaharat(item.id, this.Token).subscribe(
      data => {
        if (item.del == false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully")
        this.ReadData_AzmoonMaharat()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  //#region AzmoonMaharat Form

  Selected_AzmoonMaharat_Record: AzmoonMaharatMain_Interface
  Selected_AzmoonMaharat_Record_Switcher: string = 'List'
  Set_List_AzmoonMaharat_View() {
    this.ReadData_AzmoonMaharat()
    this.Selected_AzmoonMaharat_Record_Switcher = 'List'
  }

  Set_Form_AzmoonMaharat_View(item: AzmoonMaharatMain_Interface, Switcher: string) {
    this.Selected_AzmoonMaharat_Record = item
    this.Selected_AzmoonMaharat_Record_Switcher = Switcher
  }

  Set_Form_AzmoonMaharat_View_Add() {
    this.Selected_AzmoonMaharat_Record = Empty_AzmoonMaharatMain_Interface()
    this.Selected_AzmoonMaharat_Record_Switcher = 'Form'
  }

  //#endregion


}
